var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Label } from '../Label';
import { BaseTextInput, BaseTextArea, FormTextElementWrapper, } from './BaseFormText';
import { FormTextProvider, FormTextConsumer } from './context';
import { useFormText } from './useFormText';
import { filterFormTextProps } from './utils';
var StyledLabel = styled(Label)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var FormText = function (props) {
    var _a = useFormText({ props: props }), variant = _a.variant, labelContent = _a.labelContent, className = _a.className, formTextId = _a.formTextId, describedBy = _a.describedBy, hasError = _a.hasError, isDisabled = _a.isDisabled, formFieldHelper = _a.formFieldHelper, inlineContextualHelp = _a.inlineContextualHelp, characterCounterWidth = _a.characterCounterWidth;
    return (React.createElement(FormTextProvider, { className: className },
        React.createElement(FormTextConsumer, null, function (value) {
            if (value.hasError !== hasError)
                value.setError(hasError);
            if (value.isDisabled !== isDisabled)
                value.setDisabled(isDisabled);
            return (React.createElement(React.Fragment, null,
                React.createElement(StyledLabel, { htmlFor: formTextId }, labelContent),
                variant === 'input' && (React.createElement(FormTextElementWrapper, { formTextElement: React.createElement(BaseTextInput, __assign({}, filterFormTextProps(props), { id: formTextId, "aria-describedby": describedBy, characterCounterWidth: characterCounterWidth })), formFieldHelper: formFieldHelper, inlineContextualHelp: inlineContextualHelp })),
                variant === 'textarea' && (React.createElement(FormTextElementWrapper, { formTextElement: React.createElement(BaseTextArea, __assign({}, filterFormTextProps(props), { id: formTextId, "aria-describedby": describedBy })), formFieldHelper: formFieldHelper, inlineContextualHelp: inlineContextualHelp }))));
        })));
};
export { FormText };
var templateObject_1;
//# sourceMappingURL=FormText.js.map